var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 9.66638L7.7614 12.8805C7.84886 12.9242 7.89259 12.9461 7.93845 12.9547C7.97908 12.9623 8.02076 12.9623 8.06139 12.9547C8.10725 12.9461 8.15098 12.9242 8.23843 12.8805L14.6666 9.66638M1.33325 6.33305L7.7614 3.11897C7.84886 3.07525 7.89259 3.05338 7.93845 3.04478C7.97908 3.03716 8.02076 3.03716 8.06139 3.04478C8.10725 3.05338 8.15098 3.07525 8.23843 3.11897L14.6666 6.33305L8.23843 9.54713C8.15098 9.59085 8.10725 9.61272 8.06139 9.62132C8.02076 9.62895 7.97908 9.62895 7.93845 9.62132C7.89259 9.61272 7.84886 9.59085 7.7614 9.54713L1.33325 6.33305Z",
    stroke: "color",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan_icon.188e1422ad2bbf1326ddb5e174ad70af.svg";
export { ForwardRef as ReactComponent };